import { ReactElement } from "react";
import { showRequestErrorToast } from "../services/ErrorService";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Loading } from "./loading/Loading";
import { getNotableItems } from "../queries/notableItemQueries";
import { NotableItems as NotableItemsTable } from "@idwal/idwal-react-components";
import { sendGAEvent } from "../services/AnalyticsService";
import { GA_BUTTON_EVENT } from "../constants/GaEvents";
import {useAuthenticator} from "@aws-amplify/ui-react";

export const NotableItems = (): ReactElement => {
    const { t } = useTranslation("locale");
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [context.authStatus, context.user]);

    if (!inspectionId) {
        console.error("No inspection id.");
        showRequestErrorToast("Notable Items");
        return <div />;
    }

    const { data, isError, error, isLoading } = getNotableItems(inspectionId, user);

    if (isLoading || data == undefined) return <Loading />;

    if (isError) {
        console.error(error);
        showRequestErrorToast("Notable Items");
        return <div />;
    }

    if (data.length === 0) {
        return (
            <div
                className="flex justify-content-center align-items-center h-3rem"
                style={{ backgroundColor: "#FCFCFC" }}
            >
                {t("defects.noNotableItems")}
            </div>
        );
    }

    const handleAnalyticsEvent = (action: string) => {
        sendGAEvent(GA_BUTTON_EVENT, action);
    }

    return (
        <NotableItemsTable notableItems={data} sendAnalyticsEvent={handleAnalyticsEvent} showImageGrid={false} />
    );
};
